import { Component, input, signal } from '@angular/core';
import { Faq } from '../../../../data-access/models/faq.model';
import { BorderColorsEnum, NgxDividerComponent } from '@digipay/ngx-divider';

@Component({
  selector: 'app-faq-item',
  templateUrl: './faq-item.component.html',
  styleUrls: ['./faq-item.component.scss'],
  standalone: true,
  imports: [NgxDividerComponent],
})
export class FaqItemComponent {
  data = input<Faq>();
  isLastItem = input<boolean>();
  isExpand = signal<boolean>(false);
  protected readonly BorderColorsEnum = BorderColorsEnum;

  toggleShow() {
    this.isExpand.set(!this.isExpand());
  }
}
